# Currently Not For Code Review
rjm.ui.ChartBuilderTimeOptionsSpecificView = Backbone.View.extend(
  events:
    "click #saveSpecificDateRange": "save"
    "changeDate .datepicker" : "validateDatePicker"
    "click .oldest": "oldestHandler"
    "click .now": "nowHandler"

  initialize: (options) ->
    if not options or not options.timeFrameModel or not options.el or not options.chartModel
      throw "InvalidConstructorArgs - ChartBuilderTimeOptionsSpecificView"

    _.bindAll this, "oldestHandler", "nowHandler", "validateDatePicker", "getStartDatePicked", "getEndDatePicked", "save", "convertDateObjToDateString", "convertDateStringToDateObject", "getSpecificStart", "getSpecificEnd", "generateTemplateData", "render"
    @model = options.timeFrameModel
    @chartModel = options.chartModel
    @el = options.el
    return

  oldestHandler: (e) ->
    $('#startDate').attr('value','Oldest Available')
    return false

  nowHandler: (e) ->
    $('#endDate').attr('value','Now')
    return false

  validateDatePicker: (e) ->
    startDate = @getStartDatePicked()
    endDate = @getEndDatePicked()

    #make sure the start date is always less than or equal to the end date
    if startDate? and endDate? and startDate > endDate
        startDate.setDate startDate.getDate() + 1
        $('.datepicker.end').datepicker('setValue', @convertDateObjToDateString startDate)
    
    if e.viewMode is "days"
      $(e.target).datepicker('hide')
    
    return

  getStartDatePicked: ->
    startDateString = $('#startDate').val()

    unless startDateString is '' or startDateString is 'Oldest Available'
      return @convertDateStringToDateObject startDateString

    #GA charts require to have a start date, so use the date from 2 years ago if no start date was specified
    if @chartModel.isGAChart()
      return (2).years().ago()

    return null

  getEndDatePicked: ->
    endDateString = $('#endDate').val()

    unless endDateString is '' or endDateString is 'Now'
      return @convertDateStringToDateObject endDateString

    return null

  save: (e) ->
    startDate = @getStartDatePicked()
    endDate = @getEndDatePicked()
    @model.set start: startDate
    @model.set end: endDate
    @model.set type: rjm.app.enums.timeFrameType.SPECIFIC
    
    return

  zeroPad: (num,count) ->
    numZeropad = num + ''
    while(numZeropad.length < count)
      numZeropad = "0" + numZeropad

    return numZeropad

  convertDateObjToDateString: (dateObj) ->
    year = dateObj.getFullYear()
    month = @zeroPad(dateObj.getMonth() + 1, 2)
    day = @zeroPad(dateObj.getDate(), 2)
    return year + "-" + month + "-" + day

  convertDateStringToDateObject: (dateString) ->
    #NOTE: I didnt use the Date.parse() method because it assumes the date is midnight at UTC,
    #   but we want it to INCLUDE the current day so we want it to be as close as possible
    #   to the NEXT day
    pattern = /(\d{4})-(\d{2})-(\d{2})/
    matchArray = pattern.exec(dateString)
    year = matchArray[1]
    month = matchArray[2] - 1
    day = matchArray[3]
    return new Date(year, month, day, 0, 0, 0, 0)

  getSpecificStart: ->
    if @model.get("type") is rjm.app.enums.timeFrameType.SPECIFIC
      if (_(@model.get("start")).isDate()) then @convertDateObjToDateString(@model.get("start")) else "Oldest Available"
    else
      null

  getSpecificEnd: ->
    if @model.get("type") is rjm.app.enums.timeFrameType.SPECIFIC
      if (_(@model.get("end")).isDate()) then @convertDateObjToDateString(@model.get("end")) else "Now"
    else
      null

  generateTemplateData: ->
    startDate: @getSpecificStart()
    endDate: @getSpecificEnd()
    startRequired: @chartModel.isGAChart()

  render: ->
    $(@el).html ich["chartBuilderTimeOptions.specific"](@generateTemplateData())

    $('.input-append.datepicker').datepicker()

)